import React from 'react';
import styled from 'styled-components';
import { ReactComponent as ExecIcon } from 'assets/exclamation.svg';
import { branch, renderNothing } from 'recompose';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled(ExecIcon)`
  width: 30px;
  height: 30px;
  margin-right: 10px;
`;

const FailureChanged = ({ message }: IProps) => {
  return (
    <Wrapper>
      <Icon />
      {message}
    </Wrapper>
  );
};

export default branch(
  ({ isOpen }: IProps) => !isOpen && typeof isOpen !== 'undefined',
  renderNothing,
)(FailureChanged);

interface IProps {
  message: string;
  isOpen?: boolean;
}
